import React from 'react';
import { useRouter } from 'next/router';

import CoreMenuHeader from 'src/dispensary/core-menu/components/core-menu-header';
import CoreMenuFooter from 'src/dispensary/core-menu/components/core-menu-footer';
import ROUTES from 'src/routes';
import { DesktopOnly } from 'shared/components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import usePaths from 'hooks/use-paths';

import { LayoutWrapper } from './layout-wrapper';

type CoreMenuLayoutProps = {
  children: React.ReactNode;
};

export function CoreMenuLayout(props: CoreMenuLayoutProps): JSX.Element | null {
  const { children } = props;
  const { dispensary } = useDispensary();
  const router = useRouter();
  const { route } = usePaths();

  const isProductPage = router.route === `${route}${ROUTES.PRODUCT_ID}`;

  if (!dispensary) {
    return null;
  }

  return (
    <LayoutWrapper>
      {isProductPage ? (
        <DesktopOnly display='flex'>
          <CoreMenuHeader dispensary={dispensary} />
        </DesktopOnly>
      ) : (
        <CoreMenuHeader dispensary={dispensary} />
      )}
      {children}

      <DesktopOnly display='block'>
        <CoreMenuFooter />
      </DesktopOnly>
    </LayoutWrapper>
  );
}
